@if (showActions()) {
  <div class="bpm-actions d-flex flex-column align-items-center pt-4 mt-3">
    @if (stepHint()) {
      <div class="alert alert-light border py-2 px-3 small mb-3 w-100 bpm-hint" style="max-width: 36rem;">
        <i class="fas fa-info-circle me-1 text-primary"></i>
        {{ stepHint() }}
        @if (documentTypeSlug() && stepRequiresDocument()) {
          <span class="text-muted ms-1">({{ documentTypeSlug() }})</span>
        }
      </div>
    }

    @if (blockedReason()) {
      <div class="alert alert-warning py-2 px-3 small mb-3 w-100" style="max-width: 36rem;">
        <i class="fas fa-exclamation-triangle me-1"></i>
        {{ blockedReason() }}
      </div>
    }

    @if (sessionHold()) {
      <a class="btn btn-primary btn-sm px-4" [routerLink]="['/solicitudes/sesion', sessionHold()!.uuid]">
        <i class="fas fa-users me-2"></i>Ir a la sesión
      </a>
    } @else if (!hideButtons()) {
    <div class="d-flex gap-3 justify-content-center flex-wrap">
      @if (canAct()) {
        <span [attr.title]="blockedReason() || null">
          <button type="button"
            class="btn btn-success btn-sm px-5"
            (click)="onApproveClick()"
            [disabled]="!canConfirmApprove()">
            <i class="fas fa-check-circle me-2"></i>
            {{ approveActionLabel() }}
          </button>
        </span>
      }

      @if (showDelete()) {
        <button type="button"
          class="btn btn-outline-danger btn-sm px-4"
          (click)="deleteRequest.emit()"
          [disabled]="isProcessing()">
          <i class="fas fa-trash-alt me-2"></i>Desechar
        </button>
      }

      @if (showRejectButton()) {
        <button type="button"
          class="btn btn-outline-danger btn-sm px-4"
          (click)="onRejectClick()"
          [disabled]="isProcessing()">
          <i class="fas fa-times me-2"></i>Rechazar
        </button>
      }
    </div>
    }
  </div>
}

<app-step-approval-modal
  [request]="request()"
  [isProcessing]="isProcessing()"
  (confirmed)="onModalConfirmed($event)">
</app-step-approval-modal>
